import { Spacer } from '@ui';
import Loader from 'components/Loader';
import useSWR from 'swr';

interface Props {
    blockingId: number;
    withSpacer?: boolean;
}

export const HypotheticalPriceComponent = ({ blockingId, withSpacer }: Props) => {
    const { data, isLoading } = useSWR<{ data: { [x: string]: { title: string; price: number } } }>(
        `space/blocking/${blockingId}/price`
    );

    return (
        <Loader isLoading={isLoading}>
            {data?.data !== null && (
                <>
                    {withSpacer && <Spacer y={1} />}
                    <h5>Hypothetischer Preis</h5>
                    <div className="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-10 tw-gap-y-4">
                        {Object.values(data?.data || {}).map(({ title, price }) => (
                            <>
                                <span>{title}</span>
                                <span className="tw-whitespace-nowrap tw-font-bold">{price} €</span>
                            </>
                        ))}
                    </div>
                </>
            )}
        </Loader>
    );
};
